import { shouldRunLocalHostPath } from './offlineQueueConstants';

/**
 * Run a host server command, or enqueue it when Offline mode is on.
 * Live mode always waits for the server — it does not race into a local log.
 */
export async function runHostCommandWithOfflineFallback({
  offlineQueue,
  type,
  payload,
  start,
  snapshot = null,
  session = null,
}) {
  if (!offlineQueue || !shouldRunLocalHostPath(offlineQueue, session)) {
    return start();
  }
  await offlineQueue.enqueue({ type, ...payload }, snapshot);
  return { ok: true, local: true };
}
